// extracted by mini-css-extract-plugin
module.exports = {"jddetail-wrapper":"page_jddetail-wrapper__jh8AP","list-point":"page_list-point__EdnaU","jddetail-card":"page_jddetail-card__8xdLG"};